import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { CampusNewsEventsRoutingModule } from './campus-news-events-routing.module';
import { CampusNewsEventsListComponent } from './campus-news-events-list/campus-news-events-list.component';
import { CampusNewsEventsCreateComponent } from './campus-news-events-create/campus-news-events-create.component';

@NgModule({
  declarations: [CampusNewsEventsListComponent, CampusNewsEventsCreateComponent],
  imports: [
    CommonModule,
    CampusNewsEventsRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class CampusNewsEventsModule { }
